import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { softwareList } from "@/mocks/software";

export default function CategorySection() {
  return (
    <section className="w-full max-w-[1240px] mx-auto px-4 md:px-6 pt-14 md:pt-16">
      <div className="flex items-end justify-between gap-4 mb-6">
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">软件分类快捷入口</h2>
          <p className="mt-1.5 text-sm text-foreground-600">按使用场景划分主要分类，快速定位所需应用类型</p>
        </div>
        <Link to="/search?q=" className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap">
          查看全部软件
          <span className="flex items-center justify-center w-4 h-4"><i className="ri-arrow-right-line" aria-hidden="true"></i></span>
        </Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {categories.map((cat, i) => {
          const count = softwareList.filter((s) => s.categoryId === cat.id).length;
          return (
            <Link
              key={cat.id}
              to={`/category/${cat.id}`}
              className="group bg-background-50 rounded-lg border border-background-200 p-5 transition-all duration-300 hover:border-primary-300 hover:-translate-y-0.5 animate-fade-up cursor-pointer"
              style={{ animationDelay: `${i * 60}ms` }}
            >
              <div className="flex items-center justify-between">
                <span className="flex items-center justify-center w-12 h-12 rounded-lg bg-primary-100 text-primary-600 text-2xl">
                  <i className={cat.icon} aria-hidden="true"></i>
                </span>
                <span className="text-xs text-secondary-500 bg-background-100 rounded-full px-2.5 py-1">{count} 款软件</span>
              </div>
              <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
                {cat.name}
              </h3>
              <p className="mt-1.5 text-xs text-foreground-600 leading-relaxed line-clamp-2">{cat.description}</p>
              <div className="mt-3.5 flex flex-wrap gap-1.5">
                {cat.subcategories.slice(0, 3).map((sub) => (
                  <span key={sub} className="text-[11px] text-secondary-600 bg-secondary-100 rounded-full px-2 py-0.5">{sub}</span>
                ))}
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}